import React from 'react';
import '../../../assets/styles/About.css';
import Navbar from '../../../components/AuctionFeatureComponents/Home/Navbar';

const About = () => {
  return (
    <>
      <Navbar />
      <div className="container mt-5 pt-5">
        <div className="content-section">
          <h1>LiveAuction – Your All-in-One Sports Auction Platform</h1>
          
          <p className="lead">
            LiveAuction is a powerful online platform designed to simplify and enhance player auctions for all types of sports tournaments. 
            Whether you're organizing a cricket, volleyball, or football event, LiveAuction helps you manage your auction with ease, 
            transparency, and real-time engagement.
          </p>
          
          <p>
            We provide a feature-rich experience to help organizers, team owners, and audiences enjoy smooth and professional online auctions.
          </p>
          
          <h2 className="mt-5">Key Features of  Live Auction</h2>
          
          <ul className="features-list">
            <li><strong>Online Player Registration</strong> – Collect player details effortlessly through a customizable online form.</li>
            <li><strong>Real-Time Auction Updates</strong> – Instantly broadcast live updates for audiences and team owners.</li>
            <li><strong>Pre-Auction & Post-Auction Reports</strong> – Generate player lists and team summaries in PDF formats.</li>
            <li><strong>Flexible Auction Modes</strong> – Conduct auctions in random order sequence as per your tournament rules.</li>
            <li><strong>Customizable Settings</strong> – Set up base prices, bid increments, and point rules to match your format.</li>
            <li><strong>Automatic Point Calculations</strong> – Track used/available budget, and maximum bid value in real time.</li>
            <li><strong>Live Streaming Overlay</strong> – Auto-updating overlay integration for a live broadcast experience.</li>
            <li><strong>Organizer Dashboard</strong> – Manage players, teams, bids, and reports with a simple, intuitive interface.</li>
            <li><strong>Notifications & Alerts</strong> – Keep team owners informed with instant notifications for key auction events.</li>
          </ul>
          
          <p className="mt-4">
            <strong>And that's just the beginning — LiveAuction is constantly evolving to make your auction smarter, faster, and more exciting!</strong>
          </p>
          
          <div className="contact-section mt-5">
            <h2>Want to know more?</h2>
            <p>
              If you're planning to conduct your next sports player auction online, or want a personalized demo, feel free to reach out to us.
            </p>
            <p className="highlight">
              <strong>Live Auction – Turning your sports auction into a seamless digital experience.</strong>
            </p>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-dark text-white text-center py-3 mt-5">
        <p>© 2025 LiveAuction. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy">Privacy Policy</a> | 
          <a href="/terms-of-service"> Terms of Service</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </>
  );
};

export default About;